export default __webpack_public_path__ + "static/media/mastercard.c70c8f0c.svg";